import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentAnalysisViewMode } from '@features/dashboard/document-analysis/document-analysis.model';

@Component({
  selector: 'app-document-analysis-toolbar',
  templateUrl: './document-analysis-toolbar.component.html',
  styleUrls: ['./document-analysis-toolbar.component.scss'],
  standalone: false,
})
export class DocumentAnalysisToolbarComponent {
  /** Quantidade de empresas exibidas — reflete o filtro aplicado. */
  @Input() companiesCount: number = 0;
  @Input() viewMode: DocumentAnalysisViewMode = 'table';
  @Input() isLoading: boolean = false;

  @Output() searchChange = new EventEmitter<string>();
  @Output() viewModeChange = new EventEmitter<DocumentAnalysisViewMode>();

  get companiesLabel(): string {
    return this.companiesCount === 1 ? 'empresa' : 'empresas';
  }

  selectView(mode: DocumentAnalysisViewMode): void {
    if (mode !== this.viewMode) {
      this.viewModeChange.emit(mode);
    }
  }
}
